<svg width="33" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16.114 1.84811C16.5022 1.17563 17.4729 1.17563 17.8611 1.84811L31.8384 26.0575C32.2267 26.73 31.7414 27.5706 30.9648 27.5706H3.01023C2.23371 27.5706 1.74839 26.73 2.13665 26.0575L16.114 1.84811Z"
    fill="#007AFF"
    stroke="#0000FF"
    stroke-width="2" />
</svg>
